import { Tag } from "@/graphql/generated/graphql";
import { Slice } from "../store.decl";

export type TagSliceState = {
  activeTags: Tag[];
  setActiveTags: (tags: Tag[]) => void;
  tagIds: string[];
  setTagIds: (ids: string[]) => void;
  mutationLoading: boolean;
  setMutationLoading: (bool: boolean) => void;
};

export const createTagSlice: Slice<TagSliceState> = (set) => ({
  activeTags: [],
  setActiveTags: (activeTags) => {
    set(() => ({
      activeTags,
    }));
  },
  tagIds: [],
  setTagIds: (tagIds) => {
    set(() => ({
      tagIds,
    }));
  },
  mutationLoading: false,
  setMutationLoading: (bool) =>
    set(() => ({
      mutationLoading: bool,
    })),
});
